import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        meta: {
            title: '首页 | 福建人民出版社 - 融媒体交互式电子书，新形态智能立体化数字教材',
            // orgId: process.env.VUE_APP_XZSJ_ORG_ID
        },
        component: () => import('@/views/HomeView'),
    },
    {
        path: '/f',
        name: 'frame',
        component: () => import('@/views/FrameView'),
        redirect: 'moso-books',
        // The default page is browse books by categories
        // when the route goes to search page, I hope the link button on app bar keeps the active class
        // so the book-by-category path is moso-books without trailing path
        children: [
            {
                path: 'moso-books',
                name: 'moso-books-book-by-category',
                meta: {
                    title: '数字教材分类｜福建人民出版社 - 融媒体交互式电子书，新形态智能立体化数字教材',
                },
                component: () =>
                    import('@/views/moso-books/BookByCategoryView'),
            },
            {
                path: 'moso-books/book-list',
                name: 'moso-books-book-list',
                component: () => import('@/views/moso-books/BookListView'),
                meta: {
                    hideSearch: true,
                },
            },
            {
                path: 'moso-books/detail/:id',
                name: 'moso-books-book-detail',
                component: () => import('@/views/moso-books/BookDetailView'),
            },
            {
                path: 'cloud-books/book-list',
                name: 'cloud-books-book-list',
                component: () => import('@/views/moso-books/BookListView'),
                meta: {
                    hideSearch: true,
                },
            },
            {
                path: 'cloud-books/detail/:id',
                name: 'cloud-books-book-detail',
                component: () => import('@/views/moso-books/BookDetailView'),
            },
            {
                path: 'login',
                name: 'login',
                meta: {
                    title: '登录 | 福建人民出版社',
                    hideSearch: true,
                },
                component: () => import('@/views/user/LoginView'),
            },
            {
                path: 'register',
                name: 'register',
                meta: {
                    title: '注册 | 福建人民出版社',
                    hideSearch: true,
                },
                component: () => import('@/views/user/RegisterView'),
            },
            {
                path: 'forget-password',
                name: 'forget-password',
                meta: {
                    title: '忘记密码 | 福建人民出版社',
                    hideSearch: true,
                },
                component: () => import('@/views/user/RegisterView'),
            },
            {
                path: 'user-center',
                component: () => import('@/views/user/UserFrameView'),
                children: [
                    {
                        path: '',
                        redirect: 'profile',
                    },
                    {
                        path: 'profile',
                        name: 'profile',
                        meta: {
                            title: '账号设置｜福建人民出版社 - 融媒体交互式电子书，新形态智能立体化数字教材',
                            hideSearch: true,
                        },
                        component: () => import('@/views/user/ProfileView'),
                    },
                    {
                        path: 'shelf',
                        name: 'shelf',
                        meta: {
                            title: '我的书架｜福建人民出版社 - 融媒体交互式电子书，新形态智能立体化数字教材',
                            hideSearch: true,
                        },
                        component: () => import('@/views/user/ShelfView'),
                    },
                    {
                        path: 'trade',
                        name: 'trade',
                        meta: {
                            title: '交易明细｜福建人民出版社 - 融媒体交互式电子书，新形态智能立体化数字教材',
                            hideSearch: true,
                        },
                        component: () => import('@/views/user/TradeView'),
                    },
                ],
            },
            {
                path: 'download',
                name: 'download',
                meta: {
                    title: '客户端下载｜福建人民出版社 - 融媒体交互式电子书，新形态智能立体化数字教材',
                    hideSearch: true,
                },
                component: () => import('@/views/footer/DownloadView'),
            },
            {
                path: 'help',
                name: 'help',
                meta: {
                    title: '使用帮助｜福建人民出版社 - 融媒体交互式电子书，新形态智能立体化数字教材',
                    hideSearch: true,
                },
                component: () => import('@/views/footer/DownloadView'),
            },
            {
                path: 'certs',
                name: 'certs',
                component: () =>
                    import('@/views/certs/CertificationListView.vue'),
                meta: {
                    title: '资质',
                    hideSearch: true,
                },
            },
            {
                path: 'terms-of-use',
                name: 'terms-of-use',
                component: () => import('@/views/footer/TermsOfUseView'),
                meta: {
                    title: '使用条款',
                    hideSearch: true,
                },
            },
            {
                path: 'privacy-policy',
                name: 'privacy-policy',
                component: () => import('@/views/footer/PrivacyPolicyView.vue'),
                meta: {
                    title: '隐私政策',
                    hideSearch: true,
                },
            },
            {
                path: 'children-privacy-policy',
                name: 'children-privacy-policy',
                component: () =>
                    import('@/views/footer/ChildrenPrivacyPolicyView.vue'),
                meta: {
                    title: '儿童隐私政策',
                    hideSearch: true,
                },
            },
        ],
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.path.indexOf('/moso-books') >= 0) {
        Object.assign(to.meta, {
            orgId: process.env.VUE_APP_ORG_ID,
        });
    }

    // if (to.path.indexOf('/cloud-books') >= 0) {
    //     Object.assign(to.meta, {
    //         orgId: process.env.VUE_APP_XZSJ_ORG_ID
    //     });
    // }

    if (to.meta.title) document.title = to.meta.title;

    next();
});

router.afterEach((to, form, next) => {
    window.scrollTo(0, 0);
});

export default router;
